var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2237 1.60526L11.1768 1.65521L12.1195 1.80451L13.0414 2.05154L13.9325 2.39358L14.7829 2.82689L15.5833 3.34672L16.3251 3.94737L17 4.62226L17.6006 5.364L18.1205 6.16447L18.5538 7.01488L18.8958 7.90593L19.1428 8.82785L19.2921 9.77054L19.3421 10.7237L19.2921 11.6768L19.1428 12.6195L18.8958 13.5414L18.5538 14.4325L18.1205 15.2829L17.6006 16.0833L17 16.8251L16.3251 17.5L15.5833 18.1006L14.7829 18.6205L13.9325 19.0538L13.0414 19.3958L12.1195 19.6428L11.1768 19.7921L10.2237 19.8421L9.27054 19.7921L8.32785 19.6428L7.40593 19.3958L6.51488 19.0538L5.66447 18.6205L4.864 18.1006L4.12226 17.5L3.44737 16.8251L2.84672 16.0833L2.32689 15.2829L1.89358 14.4325L1.55154 13.5414L1.30451 12.6195L1.15521 11.6768L1.10526 10.7237L1.15521 9.77054L1.30451 8.82785L1.55154 7.90593L1.89358 7.01488L2.32689 6.16447L2.84672 5.364L3.44737 4.62226L4.12226 3.94737L4.864 3.34672L5.66447 2.82689L6.51488 2.39358L7.40593 2.05154L8.32785 1.80451L9.27054 1.65521L10.2237 1.60526Z",
    fill: "#D20E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4109 8.23685L8.30274 14.345L5.52631 11.5686",
    stroke: "#FBFBFB",
    strokeWidth: 1.66015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRed);
export default __webpack_public_path__ + "static/media/CheckRed.08f3d884.svg";
export { ForwardRef as ReactComponent };